import {TextField} from '@material-ui/core'
import React from 'react'
import {Controller, FieldValues} from 'react-hook-form'

import {handleNoSpecialCharacters} from '../../../../common/utils/handleNoSpecialCharacters'
import {useTranslation} from '../../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../../Skeleton/UserInformationInputSkeleton'
import {UserInformationProps} from '../types'
import {useStyles} from '../UserInput.styles'

export const UserCompanyInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  isLoading,
  name
}: UserInformationProps<T>) => {
  const {t} = useTranslation()
  const errors = formMethods.formState.errors
  const touched = formMethods.formState.touchedFields
  const classes = useStyles()

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  return (
    <Controller
      name={name}
      control={formMethods.control}
      rules={{validate: (value) => handleNoSpecialCharacters(value, t)}}
      render={({field}) => (
        <TextField
          {...field}
          value={readonlyMode && !field.value ? '-' : field.value}
          data-test-id={`userInformationForm-${field.name}`}
          className={classes.textField}
          fullWidth
          id="companyName"
          label={t('userInformationForm.company')}
          autoComplete="organization"
          margin="normal"
          error={touched['companyName'] && !!errors.companyName}
          helperText={errors?.[name]?.message as string}
          style={{maxWidth: 320}}
          InputProps={{readOnly: readonlyMode, disableUnderline: readonlyMode}}
        />
      )}
    />
  )
}
